<div class="card">
  <div class="card-header">
    <h4 class="card-title">{{ 'MENU.DASHBOARD.privacy_policy' | translate }}</h4>
  </div>
  <div class="card-body">
    <p class="card-text">{{ 'MENU.DASHBOARD.add_privacy_policy' | translate }}</p>
  </div>
</div>

<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="about-section">

      <div class="row">

        <div class="col-md-12 col-12 mb-3">
          <div class="card shadow-sm border-0 rounded-3">
            <div class="card-body">

              <label class="form-label fw-bold">
                {{ 'MENU.DASHBOARD.title' | translate }}
              </label>
              <input
                type="text"
                class="form-control mb-2"
                [(ngModel)]="vision.title"
                placeholder="{{ 'MENU.DASHBOARD.title' | translate }}"
              />

              <label class="form-label fw-bold">
                {{ 'MENU.DASHBOARD.content' | translate }}
              </label>
              <textarea
                class="form-control content-textarea mt-1"
                [(ngModel)]="vision.content"
                rows="10"
                placeholder="{{ 'MENU.DASHBOARD.content' | translate }}"
              ></textarea>

            </div>
          </div>
        </div>

      </div>

      <div class="text-center mt-4">
        <!-- <button class="btn btn-primary px-5 py-2 save-btn" (click)="updateProduct()">
          {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button> -->
      </div>

    </section>
  </div>
</div>
